module.exports = __webpack_public_path__ + "img/image.4dd198c2.svg";